export const ALL_TEAMS = {
	// Grupo A
	MEX: { id: 'MEX', name: 'México', slug: 'mexico' },
	RSA: { id: 'RSA', name: 'Sudáfrica', slug: 'sudafrica' },
	KOR: { id: 'KOR', name: 'Corea del Sur', slug: 'corea-del-sur' },
	RCE: {
		id: 'RCE',
		name: 'República Checa',
		slug: 'republica-checa',
	},

	// Grupo B
	CAN: { id: 'CAN', name: 'Canadá', slug: 'canada' },
	BOS: {
		id: 'BOS',
		name: 'Bosnia',
		slug: 'bosnia',
	},
	QAT: { id: 'QAT', name: 'Qatar', slug: 'qatar' },
	SUI: { id: 'SUI', name: 'Suiza', slug: 'suiza' },

	// Grupo C
	BRA: { id: 'BRA', name: 'Brasil', slug: 'brasil' },
	MAR: { id: 'MAR', name: 'Marruecos', slug: 'marruecos' },
	HAI: { id: 'HAI', name: 'Haití', slug: 'haiti' },
	SCO: { id: 'SCO', name: 'Escocia', slug: 'escocia' },

	// Grupo D
	USA: { id: 'USA', name: 'Estados Unidos', slug: 'estados-unidos' },
	PAR: { id: 'PAR', name: 'Paraguay', slug: 'paraguay' },
	AUS: { id: 'AUS', name: 'Australia', slug: 'australia' },
	TUR: {
		id: 'TUR',
		name: 'Turquía',
		slug: 'turquia',
	},

	// Grupo E
	GER: { id: 'GER', name: 'Alemania', slug: 'alemania' },
	CUW: { id: 'CUW', name: 'Curazao', slug: 'curazao' },
	CIV: { id: 'CIV', name: 'Costa de Marfil', slug: 'costa-de-marfil' },
	ECU: { id: 'ECU', name: 'Ecuador', slug: 'ecuador' },

	// Grupo F
	NED: { id: 'NED', name: 'Países Bajos', slug: 'paises-bajos' },
	JPN: { id: 'JPN', name: 'Japón', slug: 'japon' },
	SWE: {
		id: 'SWE',
		name: 'Suecia',
		slug: 'suecia',
	},
	TUN: { id: 'TUN', name: 'Túnez', slug: 'tunez' },

	// Grupo G
	BEL: { id: 'BEL', name: 'Bélgica', slug: 'belgica' },
	EGY: { id: 'EGY', name: 'Egipto', slug: 'egipto' },
	IRN: { id: 'IRN', name: 'Irán', slug: 'iran' },
	NZL: { id: 'NZL', name: 'Nueva Zelanda', slug: 'nueva-zelanda' },

	// Grupo H
	ESP: { id: 'ESP', name: 'España', slug: 'espana' },
	CPV: { id: 'CPV', name: 'Cabo Verde', slug: 'cabo-verde' },
	KSA: { id: 'KSA', name: 'Arabia Saudita', slug: 'arabia-saudita' },
	URU: { id: 'URU', name: 'Uruguay', slug: 'uruguay' },

	// Grupo I
	FRA: { id: 'FRA', name: 'Francia', slug: 'francia' },
	SEN: { id: 'SEN', name: 'Senegal', slug: 'senegal' },
	IRQ: {
		id: 'IRQ',
		name: 'Irak',
		slug: 'irak',
	},
	NOR: { id: 'NOR', name: 'Noruega', slug: 'noruega' },

	// Grupo J
	ARG: { id: 'ARG', name: 'Argentina', slug: 'argentina' },
	ALG: { id: 'ALG', name: 'Argelia', slug: 'argelia' },
	AUT: { id: 'AUT', name: 'Austria', slug: 'austria' },
	JOR: { id: 'JOR', name: 'Jordania', slug: 'jordania' },

	// Grupo K
	POR: { id: 'POR', name: 'Portugal', slug: 'portugal' },
	RDC: {
		id: 'RDC',
		name: 'RD Congo',
		slug: 'rd-congo',
	},
	UZB: { id: 'UZB', name: 'Uzbekistán', slug: 'uzbekistan' },
	COL: { id: 'COL', name: 'Colombia', slug: 'colombia' },

	// Grupo L
	ENG: { id: 'ENG', name: 'Inglaterra', slug: 'inglaterra' },
	CRO: { id: 'CRO', name: 'Croacia', slug: 'croacia' },
	GHA: { id: 'GHA', name: 'Ghana', slug: 'ghana' },
	PAN: { id: 'PAN', name: 'Panamá', slug: 'panama' },
}
